import { Menu, NotebookPen } from "lucide-react";
import { PanelModeToggle } from "./PanelModeToggle";

/* The indigo bar across the top of a SECTION of Brill — Momentum, and Me since
   2026-10-14. Lifted out of MomentumHub so the two cannot drift: her read was
   that Business, Voice, Skills, Bio and Brand were "not in the container of
   Brill", because each Me screen drew its own plain heading (Voice first, the
   other four copied it) and so had no bar, no light/dark switch and no way to
   the Library.

   Fixed indigo in both panel modes, from chrome tokens. The coloured rule and
   the icon are the section's identity, handed in by the caller.

   STRAIGHT TO THE LIBRARY, from anywhere in the section. Her ask, 2026-09-18:
   "a library icon up by the light dark button to auto select library because
   we are going to be adding ideas all the time." NotebookPen, not a lightbulb
   — the bottom bar already spends one on Academy (her own conclusion, same
   message). Teal while she is in it, or a shortcut that never changes reads as
   decoration. Omitted when no `onLibrary` is given.

   No Close: the nav (and on a phone the bottom bar) is the way out, her call
   2026-09-24. */
export function ChromeBar({ icon: Icon, title, subtitle, rule, isMobile = false, onMenuOpen, onLibrary, libraryOn = false }) {
  return (
    <div style={{ background: "var(--chrome-bg)", padding: isMobile ? "13px 14px" : "17px 22px", borderBottom: `3px solid ${rule}`, display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
      {isMobile && onMenuOpen && (
        <button onClick={onMenuOpen} aria-label="Open menu" style={{ background: "none", border: "none", cursor: "pointer", color: "var(--chrome-text)", padding: "10px 12px 10px 6px", display: "flex", minWidth: 44, minHeight: 44 }}>
          <Menu size={24} />
        </button>
      )}
      <Icon size={18} color={rule} style={{ flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <h1 style={{ color: "var(--chrome-text)", margin: 0, fontSize: isMobile ? 15 : 16, fontWeight: 700 }}>{title}</h1>
        {subtitle && <div style={{ color: "var(--chrome-text-secondary)", fontSize: 11, marginTop: 1 }}>{subtitle}</div>}
      </div>
      {onLibrary && (
        <button onClick={onLibrary} title="Library" aria-label="Library"
          style={{ background: "none", border: "1px solid var(--chrome-border-strong)", borderRadius: 8, cursor: "pointer",
            color: libraryOn ? "var(--chrome-accent)" : "var(--chrome-text)",
            borderColor: libraryOn ? "var(--chrome-accent-line)" : "var(--chrome-border-strong)",
            padding: "7px 10px", display: "flex", alignItems: "center", flexShrink: 0 }}>
          <NotebookPen size={16} />
        </button>
      )}
      <PanelModeToggle isMobile={isMobile} />
    </div>
  );
}
